// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// RxJS
import { Observable, of } from 'rxjs';

@Injectable()
export class RoleGuard implements CanActivate {
    constructor( private router: Router, private toastr: ToastrService) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean>  {        
        let role = localStorage.getItem(btoa('userrole'));
        role = atob(role);
        const isrole = route.data['role'] as string;  
        if (isrole && !isrole.includes(role)) {
            this.router.navigate(['/dashboard']).then(() => {
                this.toastr.error('Access Denied', 'Error!');
            });            
        } 
        return of(true);        
    }
}
